import { createContext } from 'react';

export default createContext({
  activeLink: null,
  striped: false
});
